export default __webpack_public_path__ + "static/media/Template8.eea94dd4.png";